import Layout from "../components/Layout"
import Stack from "@mui/material/Stack"
import { Card, Grid2 as Grid } from "@mui/material"
import { useTranslation } from "react-i18next"
import { Box } from "@mui/material"
import { PageTitle } from "../components/PageTitle"
import { Info } from "@mui/icons-material"

export default function About() {
  const { t } = useTranslation()

  return (
    <Layout padding>
      <Stack sx={{ height: "100%" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <PageTitle
            title={t("pages.about")}
            breadcrumbs={[
              {
                label: t("pages.about"),
                iconType: Info,
              },
            ]}
          />
        </Box>
        <Card sx={{ p: 4, mt: 2 }}>
          <Grid container spacing={2} mt={1}>
            <Grid size={6} offset={3} textAlign="center">
              <Box mt={2} sx={{ whiteSpace: "pre-line", fontSize: 16, color: "#333" }}>
                Home Movies Digital Archive – database gestionale e di consultazione: realizzato nell’ambito del PNRR e
                finanziato dall’Unione europea – Next Generation EU- “Transizione digitale Organismi Culturali e
                Creativi - TOCC”.
              </Box>
            </Grid>
          </Grid>
          <Grid container spacing={2} mt={8}>
            <Grid size={6} offset={3} textAlign="center">
              <Box marginTop={2} textAlign="center">
                <img src="/logo_tocc.png" alt="Logo TOCC" style={{ height: 60 }} />
              </Box>
            </Grid>
          </Grid>
        </Card>
      </Stack>
    </Layout>
  )
}
